import React, { FunctionComponent } from 'react';
import { Grid } from '@rbx/ui';
import useAppMainConfig from '@modules/ui/shared/hooks/useAppMainConfig';
import {
  FeedbackDialogType,
  ShareFeedbackProvider,
} from '@modules/feedback/context/ShareFeedbackProvider';
import useSideBarContent from '@modules/ui/shared/hooks/useSideBarContent';
import useAppLayoutMainContentStyles from './AppLayoutMainContent.styles';
import { mainID } from '../constants/layoutConstants';

export interface AppLayoutMainContentProps {
  mainNavbar?: JSX.Element;
  heading?: JSX.Element;
}

const AppLayoutMainContent: FunctionComponent<
  React.PropsWithChildren<AppLayoutMainContentProps>
> = ({ mainNavbar, heading, children }) => {
  const { mainMaxWidth } = useAppMainConfig();
  const { hasLeftNav } = useSideBarContent();
  const {
    classes: { container, contentWrapper, content },
  } = useAppLayoutMainContentStyles({
    mainMaxWidth,
    hasLeftNav,
  });
  return (
    <ShareFeedbackProvider feedbackDialogType={FeedbackDialogType.GeneralDocsFeedback}>
      <Grid item XSmall component='main' id={mainID} width='100%' className={container}>
        <Grid className={contentWrapper} maxWidth={mainMaxWidth} container>
          <Grid className={content} item XSmall>
            {mainNavbar}
            {heading}
            {children}
          </Grid>
        </Grid>
      </Grid>
    </ShareFeedbackProvider>
  );
};

export default AppLayoutMainContent;
